export class GooglePlacesService {
    public static async getAutocompleteSchools(text: string) {
        return []
    }
}